import React, { useState, useEffect } from "react";
import { collection, getDocs } from "firebase/firestore";
import { db } from "./firebaseConfig";
import { Card, CardContent } from "./components/ui/card";
import { calculateCrepeCost } from "./CrepeCostCalculator";
import { calculateCoffeeCost } from "./CoffeeCostCalculator";
import { calculateSavoryCrepeCost } from "./SavoryCrepeCostCalculator";
import Cart from "./Cart";
import Checkout from "./Checkout";
import "./App.css";

const CustomerMenu = () => {
  console.log("📌 CustomerMenu Loaded!");
  const [menu, setMenu] = useState([]);
  const [cart, setCart] = useState([]);
  const [checkout, setCheckout] = useState(false);
  const [selectedFillings, setSelectedFillings] = useState([]);
  const [selectedExtras, setSelectedExtras] = useState({
    Banana: false,
    Strawberry: false,
    PistachioCrumbs: false,
    LotusBiscuit: false,
    KinderFinger: false,
  });

  useEffect(() => {
    const fetchMenu = async () => {
      const menuCollection = await getDocs(collection(db, "inventory"));
      const fullMenu = menuCollection.docs.map((doc) => ({
        id: doc.id,
        name: doc.data().name,
        pricePerKg: doc.data().pricePerKg,
        stockKg: doc.data().stockKg,
      }));
      setMenu(fullMenu);
    };
    fetchMenu();
  }, []);

  if (!menu || menu.length === 0) {
    return <p className="text-center text-xl text-white">Loading menu...</p>;
  }

  const sellableItems = [
    "Espresso", "Cafe Latte", "Capuccino", "Spanish Latte", "Mocha Latte", "Nutella Latte", "Kinder White Latte", "Kinder White Frappe", "Nutella Frappe", "Mocha Frappe", "Spanish Frappe", "Cafe Frappe", "Oreo Milkshake", "Strawberry Milkshake", "Kinder Milkshake", "Pistachio Milkshake", "Lotus Milkshake", "Nutella Milkshake",
    "Kinder white", "Yan Yan Fraise", "Lotus Biscoff", "Pistachio Italian", "Nutella", "Oreo Hersheys", "Dark chocolate", "Triple Cheese Crepe", "Pizza Crepe",
    "Small water", "Tea", "Pepsi", "Diet Pepsi", "7up", "Diet 7up"
  ];

  const crepeFillings = ["Nutella", "Lotus Biscoff", "Pistachio Italian", "Dark chocolate", "Yan Yan Fraise", "Kinder White", "Oreo Hersheys"];

  const extraOptions = [
    { name: "Banana", price: 40000 },
    { name: "Strawberry", price: 40000 },
    { name: "Pistachio Crumbs", price: 60000 },
    { name: "Lotus Biscuit", price: 30000 },
    { name: "Kinder Finger", price: 30000 },
    { name: "Oreo", price: 30000 },
  ];

  const filteredMenu = sellableItems.map((name) => {
    const item = menu.find((menuItem) => menuItem.name === name);
    if (item) return item;
    if (name === "Small water") return { id: name, name, price: 30000 };
    if (name === "Tea") return { id: name, name, price: 100000 };
    if (name === "Pepsi" || name === "Diet Pepsi" || name === "7up" || name === "Diet 7up") return { id: name, name, price: 100000 };
    return { id: name, name };
  });

    const getItemPrice = (itemName) => {
    if (itemName === "Small water") return 30000;
    if (["Tea", "Pepsi", "Diet Pepsi", "7up", "Diet 7up"].includes(itemName)) return 100000;
    if (["Espresso", "Cafe Latte", "Capuccino", "Spanish Latte", "Mocha Latte", "Nutella Latte", "Kinder White Latte", "Kinder White Frappe", "Nutella Frappe", "Mocha Frappe", "Spanish Frappe", "Cafe Frappe", "Oreo Milkshake", "Strawberry Milkshake", "Kinder Milkshake", "Pistachio Milkshake", "Lotus Milkshake", "Nutella Milkshake"].includes(itemName)) {
      return (calculateCoffeeCost(itemName, menu) * 3.75);
    }
    if (["Triple Cheese Crepe", "Pizza Crepe"].includes(itemName)) {
      return (calculateSavoryCrepeCost(itemName, menu) * 2.72).toFixed(2);
    }
    return (calculateCrepeCost(itemName, menu) * 3.75).toFixed(2);
  };

  const getCustomCrepePrice = () => {
    if (selectedFillings.length === 0) return "Select at least one filling";
    const portion = 85 / selectedFillings.length;
    const fillingsCost = selectedFillings.reduce((total, filling) => {
      let cost = calculateCrepeCost(filling, menu) || 0;
      if (filling === "Kinder White") {
        cost = calculateCrepeCost("Kinder white", menu) || 0;
      }
      return total + cost * (portion / 85);
    }, 0);
    const extrasCost = Object.keys(selectedExtras).reduce((total, extra) => {
      return total + (selectedExtras[extra] ? extraOptions.find(e => e.name === extra).price : 0);
    }, 0);
    const totalCost = (fillingsCost * 3.75) + (extrasCost / 89500);
    return totalCost.toFixed(2);
  };

  const handleFillingSelection = (filling) => {
    setSelectedFillings((prev) => {
      if (prev.includes(filling)) {
        return prev.filter((item) => item !== filling);
      }
      if (prev.length < 3) {
        return [...prev, filling];
      }
      return prev;
    });
  };

  const handleExtraSelection = (extra) => {
    setSelectedExtras((prev) => ({
      ...prev,
      [extra]: !prev[extra],
    }));
  };

  const addCustomCrepeToCart = () => {
    if (selectedFillings.length === 0) return;
    const extras = Object.keys(selectedExtras).filter(extra => selectedExtras[extra]);
    const customCrepe = {
      id: "custom_crepe",
      name: `Custom Crepe (${selectedFillings.join(", ")}${extras.length > 0 ? `, ${extras.join(", ")}` : ""})`,
      price: parseFloat(getCustomCrepePrice()),
      quantity: 1,
    };
    setCart([...cart, customCrepe]);
  };

  if (checkout) {
    return <Checkout cart={cart} setCart={setCart} />;
  }

  return (
    <div className="chess-Background">
      <h1 className="text-3xl font-bold mb-4 text-center">Menu</h1>
      <hr/>
      <div className="bg-gray-900 p-6 rounded-lg shadow-md border border-gold mt-6">
        <h2 className="text-xl font-bold text-gold mb-2">Opening Hours</h2>
        <p className="text-white">From 2 PM till 10 PM, Thursday to Tuesday.</p>
        <h2 className="text-xl font-bold text-gold mt-2">Delivery</h2>
        <p className="text-white">Delivery is available!</p>
      </div>
      
      

      {/* Customize Your Crepe Section */}
      <div className="bg-gray-900 p-6 rounded-lg shadow-md border border-gold mt-6">
        <h2 className="text-2xl font-bold text-gold mb-2">Customize Your Crepe!</h2>
        <p className="text-gray-400">Select up to 3 preferred fillings:</p>
        <div className="mt-4">
          {crepeFillings.map((filling) => (
            <label key={filling} className="flex items-center gap-2 text-white py-1">
              <input
                type="checkbox"
                checked={selectedFillings.includes(filling)}
                onChange={() => handleFillingSelection(filling)}
                className="accent-gold"
              />
              {filling}
            </label>
          ))}
        </div>

        {/* Extra Options Section */}
        <h2 className="text-2xl font-bold text-gold mt-6">Additional Toppings</h2>
        <p className="text-gray-400">Tick the boxes to add toppings to your crepe:</p>
        <div className="mt-4">
          {extraOptions.map((extra) => (
            <label key={extra.name} className="flex items-center gap-2 text-white py-1">
              <input
                type="checkbox"
                checked={selectedExtras[extra.name]}
                onChange={() => handleExtraSelection(extra.name)}
                className="accent-gold"
              />
              {extra.name} (LBP {extra.price})
            </label>
          ))}
        </div>

        <p className="text-lg text-gray-400 font-semibold mt-4">Total Price: {(getCustomCrepePrice() * 89500) % 5000 > 2500 ? ((getCustomCrepePrice() * 89500) - (getCustomCrepePrice() * 89500) % 5000 + 5000) : ((getCustomCrepePrice() * 89500) - (getCustomCrepePrice() * 89500) % 5000)} LBP</p>
<h3>coupon option : {(getCustomCrepePrice() * 89500)<300000 ? "option 1" : (getCustomCrepePrice() * 89500)<350000 ? "option 2" : "option 3"}</h3> 
        <button onClick={addCustomCrepeToCart} className="button mt-2">Add Custom Crepe to Cart</button>
      </div>
            <h2 className="text-2xl font-bold mt-6 mb-4 text-center">Special Offers</h2>
      <div className="Display-Grid-Row">
        {[
          { name: "2 Pizza Crepes", price: 10.05 },
          { name: "2 Triple Cheese Crepes", price: 6.145 },
          { name: "1 Pizza Crepe + 1 Triple Cheese", price: 7.821 },
        ].map((offer) => (
          <Card key={offer.name} className="bg-gray-900 p-6 rounded-lg shadow-md border border-gold transform hover:scale-105">
            <CardContent>
              <h3 className="text-2xl font-bold text-gold mb-2">{offer.name}</h3>
<p className="text-lg text-gray-400"> Price: {
                                             offer.price * 89500 % 5000 > 2500 ? ((offer.price * 89500) - ((offer.price * 89500) % 5000) + 5000) : (offer.price * 89500 - ((offer.price * 89500) % 5000))} LBP </p>

              <button onClick={() => setCart([...cart, { name: offer.name, quantity: 1, price: offer.price }])} className="button">Add to Cart</button>
            </CardContent>
          </Card>
        ))}
      </div>
<div className="Display-Grid">
        {filteredMenu.map((item) => (
          <Card key={item.id} className="bg-gray-900 p-6 rounded-lg shadow-md border border-gold transform hover:scale-105">
            <CardContent>
              <h4 className="text-2xl font-bold text-gold mb-2">{item.name}</h4>
              <p className="text-lg text-gray-400">Price: {item.name === "Small water" || item.name === "Tea" || item.name === "Pepsi" || item.name === "Diet Pepsi" || item.name === "7up" || item.name === "Diet 7up" ? item.price : (getItemPrice(item.name) * 89500) % 5000 > 2500 ? ((getItemPrice(item.name) * 89500) - (getItemPrice(item.name) * 89500) % 5000 + 5000) : ((getItemPrice(item.name) * 89500) - (getItemPrice(item.name) * 89500) % 5000)} LBP</p>
              <button onClick={() => setCart([...cart, { ...item, quantity: 1, price: parseFloat(item.name === "Small water" || item.name === "Tea" || item.name === "Pepsi" || item.name === "Diet Pepsi" || item.name === "7up" || item.name === "Diet 7up" ? (item.price/89500) : (getItemPrice(item.name))) }])} className="button">Add to Cart</button>
            </CardContent>
          </Card>
        ))}
      </div>
      <Cart cart={cart} setCart={setCart} onCheckout={() => setCheckout(true)} />
          
    </div>

  );
};

export default CustomerMenu;

